<template>
  <main-layout>
    <div class="container fluid">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <h3 class="headline">{{ $t('service_center_management') }}</h3>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right pt-4 pb-2">
          <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
          <v-btn dark outline color="primary" @click="getXlsxData" :loading="loading">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn dark depressed color="primary" @click="onAdd">
            <v-icon>add</v-icon>&nbsp;{{ $t('add_service_center') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right pt-6">
          <v-btn dark depressed color="primary" @click="isShowFilterDialog = true">
            <v-icon>search</v-icon>&nbsp;{{ $t('advanced search') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="data"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1 mt-4"
      >
        <!-- hide-actions -->
        <template v-slot:items="props">
          <tr>
            <td>
              <v-chip v-if="props.item.fastlane" color="primary" small dark>Fast Lane</v-chip>
            </td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.branch || '-' }}</td>
            <td>{{ props.item.province }}</td>
            <td>{{ props.item.district }}</td>
            <td>{{ props.item.address }}</td>
            <td>{{ props.item.car_brand || '-' }}</td>
            <td>{{ props.item.store_brand || '-' }}</td>
            <td>{{ props.item.store_type }}</td>
            <td>
              <div class="d-flex">
                <v-btn icon ripple outline @click="editStore(props.item)" color="primary">
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn icon ripple outline @click="onDeleteStore(props.item.id)" color="error">
                  <v-icon>delete</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-model="isShowServiceCenterDialog" persistent width="600px">
      <ServiceCenterDialog
        v-if="isShowServiceCenterDialog"
        v-model="selectedEditStore"
        @close="isShowServiceCenterDialog = false"
        @success="onSuccess"
        :action="action"
      ></ServiceCenterDialog>
    </v-dialog>

    <v-dialog v-model="isShowFilterDialog" persistent width="600px">
      <v-card class="pa-3">
        <div class="d-flex">
          <div class="pt-3">
            <span>
              <v-icon>search</v-icon>&nbsp;
              <span class="primary--text">{{ $t('advanced search') }}</span>
            </span>
          </div>
          <div class="text-xs-right">
            <v-btn fab @click="onCloseSearchDialog" small flat><v-icon>close</v-icon></v-btn>
          </div>
        </div>
        <v-layout wrap>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <div>
                <label class="caption">{{ $t('secap_service_center_name') }} </label>
              </div>
              <input v-model="filter.name" type="text" />
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <div>
                <label class="caption">{{ $t('secap_branch') }}</label>
              </div>
              <input v-model="filter.branch" type="text" />
            </div>
          </v-flex>
          <v-flex xs12 class="px-1">
            <div class="form-control">
              <div>
                <label class="caption">{{ $t('Province') }} </label>
              </div>
              <multiselect
                v-model="filter.province"
                :options="provinceOptions"
                :allow-empty="true"
                :searchable="true"
                selectLabel
                selectedLabel
                open-direction="top"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs12 xm12 class="text-xs-center pt-3">
            <v-btn @click="onClearSearch" outline color="grey">{{ $t('Clear Search') }}</v-btn>
            <v-btn :loading="saveloading" @click="onSearch" depressed color="primary">{{
              $t('Search')
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </main-layout>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import importxlsx from '@/components/elements/importxlsx.vue'
import * as XLSX from 'xlsx'
import ServiceCenterDialog from './ServiceCenterDialog'
import Multiselect from 'vue-multiselect'
import province from '@/data/province.js'

export default {
  components: {
    importxlsx,
    ServiceCenterDialog,
    Multiselect
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 20,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: 'Fast Lane', value: '', sortable: false },
        { text: this.$t('secap_service_center_name'), value: 'name', sortable: true },
        { text: this.$t('secap_branch'), value: 'branch', sortable: true },
        { text: this.$t('Province'), value: 'province', sortable: true },
        { text: this.$t('District'), value: 'district', sortable: true },
        { text: this.$t('Address'), value: 'address', sortable: false },
        { text: this.$t('secap_car_brand'), value: 'car_brand', sortable: true },
        { text: this.$t('shop'), value: 'store_brand', sortable: true },
        { text: this.$t('secap_service_center_type'), value: 'store_type', sortable: true },
        { text: '', value: '', sortable: false }
      ],
      data: [],
      loading: false,
      importloading: false,
      isExport: false,
      isShowServiceCenterDialog: false,
      action: null,
      selectedEditStore: [],
      isShowFilterDialog: false,
      filter: {
        name: '',
        branch: '',
        province: ''
      },
      saveloading: false,
      provinceOptions: province
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getXlsxData() {
      let vm = this
      vm.isExport = true
      vm.offset = 0
      const data = await vm.getData()
      vm.isExport = false
      vm.onRefresh()

      const store = data.map((el) => {
        return {
          fastlane: el.fastlane,
          name: el.name,
          branch: el.branch,
          province: el.province,
          district: el.district,
          address: el.address,
          car_brand: el.car_brand ? el.car_brand : '-',
          store_brand: el.store_brand ? el.store_brand : '-',
          store_type: el.store_type ? el.store_type : '-'
        }
      })

      let Heading = [
        [
          `Fast Lane`,
          `${this.$t('secap_service_center_name')}`,
          `${this.$t('secap_branch')}`,
          `${this.$t('Province')}`,
          `${this.$t('District')}`,
          `${this.$t('Address')}`,
          `${this.$t('secap_car_brand')}`,
          `${this.$t('shop')}`,
          `${this.$t('secap_service_center_type')}`
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, Heading)
      XLSX.utils.sheet_add_json(ws, store, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `service-center.xlsx`)
    },
    getData() {
      return new Promise((resolve) => {
        let vm = this
        let limit = vm.isExport ? vm.total : vm.limit

        let data = {
          pageid: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        if (vm.filter.name) {
          Object.assign(data, { name: vm.filter.name })
        }
        if (vm.filter.branch) {
          Object.assign(data, { branch: vm.filter.branch })
        }
        if (vm.filter.province) {
          Object.assign(data, { province: vm.filter.province })
        }

        vm.loading = true
        api.getSecapMaintenanceStores(data, (err, response) => {
          vm.loading = false
          if (err) {
            console.error(err)
            return
          }

          if (response.responsecode == 200) {
            vm.data = response.data
            vm.total = response.total
            resolve(response.data)
          }
        })
      })
    },
    onImport(item) {
      let vm = this
      vm.importloading = true
      var data = {
        pageid: vm.selectedBot.pageid,
        files: item[0]
      }
      api.importSecapMaintenanceStores(data, async (err, response) => {
        vm.importloading = false
        if (err) {
          console.error(err)
          return
        }

        if (response && response.responsecode == 200) {
          await vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.onRefresh()
        } else {
          await vm.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      })
    },
    onAdd() {
      this.action = 'add'
      this.isShowServiceCenterDialog = true
    },
    editStore(item) {
      this.selectedEditStore = item
      this.action = 'edit'
      this.isShowServiceCenterDialog = true
    },
    onSuccess() {
      this.selectedEditStore = []
      this.isShowServiceCenterDialog = false
      this.onRefresh()
    },
    onRefresh() {
      this.limit = 20
      this.offset = 0
      this.getData()
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    onSelectAddress(address) {
      this.filter.district = address.amphoe
      this.filter.province = address.province
    },
    onSearch() {
      this.saveloading = true
      this.onRefresh()
      this.saveloading = false
      this.isShowFilterDialog = false
    },
    onCloseSearchDialog() {
      this.filter = {
        name: '',
        branch: '',
        province: '',
        district: ''
      }
      this.isShowFilterDialog = false
    },
    onClearSearch() {
      this.onCloseSearchDialog()
      this.onRefresh()
    },
    onDeleteStore(id) {
      let vm = this
      vm.$swal
        .fire({
          title: 'ยืนยันการลบศูนย์บริการ ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let data = {
              id: id,
              pageid: vm.selectedBot.pageid
            }
            api.deleteSecapMaintenanceStores(data, (err, response) => {
              if (err) {
                reject()
                return
              }

              if (response && response.responsecode == 200) {
                vm.$swal.fire({
                  type: 'success',
                  title: this.$t('Success')
                })
                vm.getData()
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/secap/ServiceCenterManagement.vue